<template>
  <HModal
    :visible="show"
    :show-close="false"
  >
    <div class="confirm">
      <div class="confirm-header">
        <p class="fl">
          {{ title }}
        </p>
        <div
          class="fr close-btn"
          @click="closeModal('close')"
        />
      </div>
      <div class="confirm-content">
        <p v-if="!$slots['content']">
          {{ content }}
        </p>
        <slot name="content" />
      </div>
      <div class="confrim-action">
        <div
          v-show="!hideCancle"
          class="btn cancle-btn"
          @click="closeModal('cancle')"
        >
          取消
        </div>
        <div
          class="btn submit-btn"
          @click="submit"
        >
          {{ submitText || '确认' }}
        </div>
      </div>
    </div>
  </HModal>
</template>

<script>
export default {
  props: {
    title: String,
    content: String,
    show: Boolean,
    submitText: String,
    hideCancle: Boolean
  },
  data () {
    return {
    }
  },
  methods: {
    closeModal (type) {
      this.$emit('close', type)
    },
    submit () {
      this.$emit('submit')
    }
  }
}
</script>
<style lang="scss" scoped>
.confirm {
  width: 400px;
  height: 180px;
  background: url(~@/assets/images/deviceAdmin/tip-bg.png) no-repeat center center;
}
.confirm-header {
  height: 28px;
  line-height: 28px;
  padding-left: 28px;
  color: #B07400;
  font-size: 12px;
  padding-right: 10px;
}
.close-btn {
  width: 12px;
  height: 12px;
  background: url(~@/assets/images/deviceAdmin/close-btn.png) no-repeat left center;
  cursor: pointer;
  margin-top: 8px;
  &:hover {
    background-position-x: center;
  }
  &:active {
    background-position-x: right;
  }
}
.confirm-content {
  padding: 32px 42px 0 42px;
  font-size: 14px;
  color: #636D78;
  word-wrap:break-word;
}
.confrim-action {
  width: 100%;
  text-align: right;
  padding-right: 20px;
  position: absolute;
  bottom: 23px;
  box-sizing: border-box;
}
.btn {
  display: inline-block;
  cursor: pointer;
}
.cancle-btn {
  margin-right: 19px;
  counter-reset: #5C5C5C;
  text-decoration: underline;
}
.submit-btn {
  background: #5DBF25;
  border-radius: 1px;
  color: #fff;
  text-align: center;
  padding: 0 32px;
  height: 30px;
  line-height: 30px;
  &:hover {
    background: #71DF33;
  }
  &:active {
    background: #4EA51C;
  }
}
</style>
